export const columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 50,
        fixed:'left',
        customRender: (text, record, index) => {
            return index + 1
        },
    },
    {
        title: '批次包号',
        dataIndex: 'pkgCode',
        key: 'pkgCode',
        width: 150,
        fixed:'left',
        scopedSlots: {
            customRender: 'pkgCode'
        }
    },
    {
        title: '商品图片',
        dataIndex: 'productImg',
        key: 'productImg',
        scopedSlots: {
            customRender: 'productImgActive'
        }
    },
    {
        title: '客户名称',
        dataIndex: 'customerShopName',
        key: 'customerShopName',
        ellipsis: true,
    },
    {
        title: '商品SKU',
        dataIndex: 'shopProductSku',
        key: 'shopProductSku',
        ellipsis: true,
    },
    {
        title: '平台SKU',
        dataIndex: 'productSku',
        key: 'productSku',
        ellipsis: true,
    },
    {
        title: '商品名称',
        dataIndex: 'productName',
        key: 'productName',
        ellipsis: true,
    },
    {
        title: '商品规格',
        dataIndex: 'productProp',
        key: 'productProp',
        ellipsis: true,
    },
    {
        title: '数量',
        dataIndex: 'amount',
        key: 'amount',
        width: 100,
        ellipsis: true,
    },
    {
        title: '操作',
        key: 'washingLabel',
        dataIndex: 'washingLabel',
        fixed:'right',
        width:150,
        scopedSlots: {
            customRender: 'washingLabel'
        }
    }
    // {
    //     title: '水洗标',
    //     key: 'washingLabel',
    //     dataIndex: 'washingLabel',
    //     width: 350,
    //     scopedSlots: {
    //         customRender: 'washingLabel'
    //     }
    // }
]
export const dataSourceMap =    {
    specs: '尺寸：XL 现货；颜色分类：黄',
    amount: 0,
    pkgCode: 'PKG38968370173',
    clientName: '客户一',
    productSku: 'SKU2342345465',
    productImg: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
    productName: '美味汉堡',
    washingLabel: '棉20% / 涤纶80%'
}